import { Component, OnInit } from '@angular/core';
import { DataGridTemplate } from '../../../../../shared/data-grid/data-grid.template';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormDialogTemplate } from '../../../../../shared/form-dialog/form-dialog.template';
import { CtwrLocationService } from '../../../ctwr.service';
import { RoleService, UserService } from '../../../../mesc/mesc.service';
import { AuthenticationService } from '../../../../../auth.service';
import { Subject } from 'rxjs';
import { FilterableService } from '../../../../mesc/filterable-service';
import { takeUntil } from 'rxjs/operators';




@Component({
  selector: 'app-locations',
  templateUrl: './locations.component.html',
  styleUrls: ['./locations.component.scss']
})
export class LocationsComponent extends DataGridTemplate implements OnInit {

  editForm: FormGroup;
  formDialog: FormDialogTemplate;
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();
  private readonly programToolEngineers: FilterableService = new FilterableService();
  private module: any;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly locationService: CtwrLocationService,
    private readonly roleService: RoleService,
    private readonly userService: UserService,
    private readonly authService: AuthenticationService,
  ) {
    super();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  ngOnInit() {
    this.formDialog = new FormDialogTemplate();
    this.modal = true;
    this.sortable = true;
    this.filterable = 'menu';
    this.gridState.sort = [{ dir: 'asc', field: 'Name' }];

    this.editForm = this.formBuilder.group({
      Id: [],
      Name: ['', Validators.compose([Validators.required, Validators.maxLength(65)])],
      Status: [],
      SiteLibPTE: ['', Validators.required]
    })

    this.formDialog.initilize("Location", this.editForm, this.formDialogTabs);
    this.formDialog.notificationLabel = { flag: 'info', state: 'edit', value: '*Editing this record may impact current, future, and past requests.' };

    this.authService.getActiveModule()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(mod => {
        this.module = mod;
        if (mod) this.updateLocationContacts();
      });

  }

  private updateLocationContacts() {
    this.roleService.read(`/GetByModule/${this.module.Id}`)
      .then(roles => {
        const path = `/GetUsersByRoleId/${this.module.Id}/`;
        const pte = roles.find(r => r.Code === 'PTE');
        this.userService.read(path + pte.Id)
          .then(x => {
            x.map(i => i.cn = `${i.FirstName} ${i.LastName}`);
            this.programToolEngineers.next(x);
          });
      });
  }

  create(parentEditDataItem: any): void {
    this.formDialog.isNew = true;
    this.formDialog.next(this.editDataItem);
    this.editForm.get('Name').enable();
  }

  read(opts: any): Promise<any> {
    return opts.force ?
      this.locationService.read('') :
      Promise.resolve(this.locationService.value);
  }

  edit(dataItem: any): void {
    this.formDialog.isNew = false;
    this.formDialog.next(this.editDataItem);
    this.editForm.get('Name').disable();
  }

  save(dataItem: any, isNew: boolean): Promise<any> {
    const _path: string = isNew ? '' : (`/${dataItem.Id}`);
    return this.locationService.save(dataItem, isNew, _path, false)
  }

  delete(dataItem: any): Promise<any> {
    return this.locationService.remove(`/${dataItem.Id}`, false)
  }

  columns: any[] = [
    {
      field: 'Name',
      title: 'Name',
    },
    {
      field: 'SiteLibryPTE',
      title: 'Site Libry PTE',
    },
  ]

  formControls = [
    {
      type: 'text',
      title: 'Name',
      name: 'Name',
      textField: 'Description',
      valueField: 'Id',
      placeholder: 'Enter a Location Name',
      stretch: true,
      invalidText: 'Input must be between 1 and 65 characters.'
    },
    {
      type: 'combobox',
      title: 'Site Library PTE',
      name: 'SiteLibPTE',
      textField: 'cn',
      valueField: 'Id',
      stretch: true,
      service: this.programToolEngineers,
    },
  ]

  formDialogTabs = [
    {
      title: "Location",
      selected: true,
      formControls: this.formControls
    },
  ]
}
